import React from 'react';
import RefreshActionMenu from '@/components/ribbon-actions/RefreshActionMenu';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const AuditsActions = ({ category, code, readStatus }) => {
  const { allowRefresh } = Selectors.useAuditsActions({ category, code });
  const refresh = Events.useRefreshAudits(category, { code });
  return (
    <>
      {allowRefresh && (<RefreshActionMenu onClick={() => refresh({ page: 1 })} readStatus={readStatus} />)}
    </>
  );
};

export default AuditsActions;
